import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconRulerSvg } from "./IconRulerSvg.mjs";
const IconRuler = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconRulerSvg, ...iconProps });
};
export {
  IconRuler
};
